import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Router} from '@angular/router';
import {from, Observable, of} from 'rxjs';
import {RoutesEnum} from '../navigation/routes.enum';
import {OnAppInitInterface, RouteUtils} from '@astek/utils';
import {NavigationService} from '../navigation/navigation.service';
import {AuthenticationService} from '../authentication/authentication.service';
import {UserRolesEnum} from '../user/user-roles.enum';

@Injectable()
export class AuthGuardService implements OnAppInitInterface<Observable<void>> {

  constructor(
    private readonly _router: Router,
    private readonly _authenticationService: AuthenticationService,
    private readonly _navigationService: NavigationService,
  ) {
  }

  public onAppInit(): Observable<void> {
    this._authenticationService.authenticationChanged().subscribe(async (authenticated: boolean) => {
      if (!authenticated) {
        await this._router.navigate([RoutesEnum.AUTHENTICATION]);
      }
    });
    return of();
  }

  public canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    const routeName: RoutesEnum = RouteUtils.routeNameFromSnapshot(route, RoutesEnum)
      ?? this._navigationService.defaultRoute;
    switch (routeName) {
      case RoutesEnum.AUTHENTICATION:
        if (this._authenticationService.isAuthenticated) {
          return from(this._router.navigate([this._navigationService.defaultRoute]));
        }
        return of(true);
      case RoutesEnum.HOME:
      case RoutesEnum.CLINICAL_REPORT:
        if (!this._authenticationService.isAuthenticated) {
          return from(this._router.navigate([this._navigationService.defaultRoute]));
        }
        return of(true);
      case RoutesEnum.HEALTH_CENTERS:
      case RoutesEnum.SETTINGS:
      case RoutesEnum.USERS:
        if (!this._authenticationService.isAuthenticated ||
          !this._authenticationService.user?.roles.includes(UserRolesEnum.ADMIN)) {
          return from(this._router.navigate([this._navigationService.defaultRoute]));
        }
        return of(true);
      case RoutesEnum.SENSORS:
      case RoutesEnum.BOXES:
        if (!this._authenticationService.isAuthenticated ||
          !this._authenticationService.user?.isAdminOrSubcontractor()) {
          return from(this._router.navigate([this._navigationService.defaultRoute]));
        }
        return of(true);
      case RoutesEnum.PATIENTS:
        if (!this._authenticationService.isAuthenticated ||
          !this._authenticationService.user?.roles.includes(UserRolesEnum.PRACTITIONER)) {
          return from(this._router.navigate([this._navigationService.defaultRoute]));
        }
        return of(true);
      default:
        return of(false);
    }
  }

}
